import { LOCAL_SERVER_URL, SERVER_URL } from "../utils/constants";

const getUsersList = async (libAddress, name) => {
  const response = await fetch(
    `${SERVER_URL}/getUsersList?address=${libAddress}&name=${name}`,
    {
      method: "get",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  if (response.status === 400) {
    return undefined;
  }
  return await response.json();
};
export default getUsersList;
